import { render } from "./CustomTabs.vue?vue&type=template&id=5e7730ce&scoped=true"
import script from "./CustomTabs.vue?vue&type=script&lang=js"
export * from "./CustomTabs.vue?vue&type=script&lang=js"

import "./CustomTabs.vue?vue&type=style&index=0&id=5e7730ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7730ce"]])

export default __exports__